import { defineStore } from "pinia";

export const useIndexStore = defineStore({
	id: "index-store",
	state: () => {
		return {
			showUserModal: false,
			modalUserText: "",
			isSidebarOpened: false,
			isSidebarLogoOpened: false,
			// Desktop-only user preference: sidebar starts expanded and only stays
			// collapsed when the user collapsed it. Persisted in a cookie so SSR agrees.
			sidebarDesktopCollapsed: false,
		};
	},
	actions: {
		toggleSidebar() {
			this.isSidebarOpened = !this.isSidebarOpened;
		},
		toggleSidebarLogo() {
			this.isSidebarLogoOpened = !this.isSidebarLogoOpened;
		},
		async toggleUserModal(text: any) {
			this.showUserModal = !this.showUserModal;
			this.modalUserText = text;
		},
		resetModal() {
			this.showUserModal = false;
			this.modalUserText = "";
		},
	},
	getters: {
		sidebarState: (state) => state.isSidebarOpened,
		sidebarLogoState: (state) => state.isSidebarLogoOpened,
		getUserModalState: (state) => state.showUserModal,
		getUserModalText: (state) => state.modalUserText,
	},
	persist: { pick: ["sidebarDesktopCollapsed"] },
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useIndexStore, import.meta.hot));
}
